<template>
  <div>
    <NoResults v-if="emptyDebriefs" class="m-4" />
    <TmsDebrief v-else-if="currentDebrief" :debrief="currentDebrief" />
    <div v-else v-for="(debriefsForDate, debriefDate) in debriefs">
      <div class="bg-dark text-light p-2">{{ debriefDate }}</div>
      <div
        v-for="debrief in debriefsForDate"
        @click="setCurrentDebrief(debrief)"
        class="m-2 debrief-wrapper cursor-pointer"
      >
        <p class="debrief-title">
          {{ getDebriefName(debrief) }}
        </p>

        <p class="debrief-date">{{ getDebriefDate(debrief) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _startCase from "lodash/startCase";
import _isEmpty from "lodash/isEmpty";
import NoResults from "@/components/NoResults";
import TmsDebrief from "@/components/Tms/TmsDebrief";

export default {
  name: "TmsScenarios",
  components: { TmsDebrief, NoResults },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("tmsStore/setCurrentDebrief", null);
    next();
  },
  computed: {
    ...mapGetters("tmsStore", ["debriefs", "currentDebrief", "isLoading"]),
    emptyDebriefs() {
      return _isEmpty(this.debriefs);
    },
  },
  methods: {
    getDebriefName(debrief) {
      return (
        debrief.name ||
        this.getScenarioName(debrief) + ", " + this.getStudentName(debrief)
      );
    },
    getScenarioName(debrief) {
      if (!debrief.scenario || !debrief.scenario.name)
        return "Unknown Scenario";
      else return debrief.scenario.name;
    },
    getStudentName(debrief) {
      if (!debrief.student || !debrief.student.name) return "Unnamed Student";
      else return _startCase(debrief.student.name);
    },
    getDebriefDate(debrief) {
      if (!debrief.createdAt) return "";
      return new Date(debrief.createdAt).toLocaleString();
    },
    setCurrentDebrief(newDebrief) {
      this.$store.commit("tmsStore/setCurrentDebrief", newDebrief);
    },
  },
};
</script>

<style scoped>
.debrief-wrapper {
  border-bottom: 1px solid #dee2e6;
}
.debrief-wrapper:last-child {
  border-bottom: 0;
}

.debrief-title {
  font-size: 1em;
  margin: 0;
}

.debrief-date {
  font-weight: lighter;
  font-size: 0.8em;
  margin: 2px 0 6px 0;
}
</style>
